"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _VideoLayout = require("../VideoLayout");
Object.keys(_VideoLayout).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _VideoLayout[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _VideoLayout[key];
        }
    });
});
var _Button = require("./Button");
Object.keys(_Button).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _Button[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _Button[key];
        }
    });
});
var _TextBox = require("./TextBox");
Object.keys(_TextBox).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _TextBox[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _TextBox[key];
        }
    });
});
var _ImageBox = require("./ImageBox");
Object.keys(_ImageBox).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _ImageBox[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _ImageBox[key];
        }
    });
});
var _Title = require("./Title");
Object.keys(_Title).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _Title[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _Title[key];
        }
    });
});
